import React from 'react';
import Layout from '../layouts/two';
import TournamentLink from './partials/tournament';
import ScrollAnimation from 'react-animate-on-scroll';
import SubNav from './partials/sub_nav';
import Boys from './partials/entries_boys';
import Girls from './partials/entries_girls';
import Groups from './partials/entries_groups';
import ESPN from './partials/espn';
import _ from 'lodash';

// Season have a flag 'ShowEntryListOrGroup' which is [1: hide, 2: show list, 3: show group]
class Entries extends React.Component {
    state = {
        entries: null,
        groupings: null
    }
    componentWillMount() {
        //const { params: { id }, entries, groupings, tournaments, upcoming, past, tournamentsActions, tournament, entriesActions } = this.props;
        const { tournaments, upcoming, past, params, tournamentsActions, entriesActions } = this.props, { id } = params;
        if ((tournaments && tournaments.length && _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((upcoming && upcoming.length && _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((past && past.length && _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        }
        entriesActions.fetch(id);
        tournamentsActions.fetch(id);
    }
    componentWillReceiveProps = nextProps => {
        const { tournament } = nextProps;
        this.setState({ tournament: this.state.tournament || tournament, });
    }
    render() {
        const { entries, params, groupings } = this.props, { id } = params, { tournament = {} } = this.state, { Medal = {} } = (tournament || {});
        let bi = (tournament && tournament.IdMedal) ? `/images/medals/${tournament.IdMedal}.jpg` : "/images/backgrounds/edoardo-busti-413350-unsplash.jpg";
        return <Layout medal={Medal} nbs="tournaments" title="ENTRIES" bi={bi}>
            <section>
                <div id="tournament" style={{ marginTop: '-4.5em' }}>
                    <div className="w3-container w3-content">
                        <div className="d-flex flex-column">
                            <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} component="li"
                                    className="w3-card margin-top" style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                    <TournamentLink hideLink={true} tournament={tournament} /></ScrollAnimation>
                            </ul>
                        </div>
                    </div>
                    { tournament && <div className="w3-container w3-content">
                        <SubNav id={id} current={3} tournament={tournament} />
                        <p className="white">Below is a list of all teams currently registered for the {tournament.Name || tournament.TournamentName}. Please check to ensure that all of the information for your team is correct.</p>
                        <p className="white">If the word “Pending” is next to your team’s name you must send an email to tournaments@challengesports.com as soon as possible, or you may be at risk of being dropped from the event.</p>
                    </div> }
                    <div className="w3-red ">
                        <div className="w3-container w3-content pt-4 pb-4">
                            <p>Teams will be placed into preliminary groups for play, no later than Monday. As the list of entries change the groups will be updated - please check back often so that you will be aware of your team's placement.</p>
                            <p>IMPORTANT: Any and all requests for scheduling and team placement considerations must be sent to us by using the "Contact" link on our web site, and must be received by us NO LATER than Tuesday night </p>
                        </div>
                    </div>
                    <div className="bg-white" style={{ position: 'relative' }}>
                        <div className="w3-container w3-content pt-4 pb-4">
                            <div className="d-flex flex-row">
                                <div className="w-100 d-flex flex-column">
                                    <p className="gray">While we make every effort to honor your requests, we regret that it may not always be possible for us to do so. Teams that feel that the circumstances will not allow them to have a positive experience have until Midnight on Tuesday to take advantage of the Challenge Sports Guarantee, which provides for a transfer of their fees to a future Challenge Sports event, or a full refund - PROVIDED they withdraw their team by submitting a contact form to us stating their wish to withdraw by midnight on Tuesday.</p>
                                    <p className="gray">Schedules will be posted on the Sports Logic schedule/standings page, (which you can link from the event information page of our web site) by 10PM on Thursday.</p>
                                </div>
                                <div style={{ width: 50 }} />
                                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} className="w-50">
                                    <img alt="" className="w-100" src="/images/others/foot_and_ball.jpg" />
                                </ScrollAnimation>
                            </div>
                        </div>
                        <span className="super-hero-text gray anton w-100 text-left w3-hide-small w3-hide-medium" style={{ position: 'absolute', bottom: -59, opacity: 0.05, left: 0 }}>ENTRIES</span>
                    </div>
                    <div className="bg-whiteish">
                        <div className="w3-container w3-content pt-4 pb-4">
                            {groupings && <Groups groupings={groupings} />}
                            {entries && entries.maleandcoed && entries.maleandcoed.teams.length > 0 && <Boys teams={entries.maleandcoed.teams} />}
                            {entries && entries.female && entries.female.teams.length > 0 && <Girls teams={entries.female.teams} />}
                        </div>
                    </div>
                    {tournament && tournament.IsESPN && <ESPN tournament={tournament} />}
                </div>
            </section>
        </Layout>
    }
}

export default Entries;



// WEBPACK FOOTER //
// ./src/components/tournaments/entries.js